import React from 'react';

import { connect } from  'react-redux';

import { Redirect, Link } from 'react-router-dom';

import {api,API_URL} from '../../actions/_request';
import swal from 'sweetalert2';
//libs
import Select , {Async}  from 'react-select';
import moment from 'moment';

import Lista_tickets from './lista_tickets_contpaq'
import * as actions from '../../actions/balancegeneral';

import {
    Card, CardBlock,
    Button, ButtonGroup,
    InputGroup, InputGroupAddon, InputGroupButton,InputGroupText,
    Input,
    Badge,
    Row,
    CardTitle
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink, CardText, Col } from 'reactstrap';
import classnames from 'classnames';
import Fasearch from 'react-icons/lib/fa/search';
import FAprint from 'react-icons/lib/fa/print';


const meses = [
	{label : 'Enero' , value : 1},
	{label : 'Febrero', value : 2},
	{label : 'Marzo', value : 3},
	{label : 'Abril' , value: 4},
	{label : 'Mayo' , value: 5},
	{label : 'Junio' , value: 6},
	{label : 'Julio' , value: 7},
	{label : 'Agosto' , value: 8},
	{label : 'Septiembre' , value: 9},
	{label : 'Octubre' , value: 10},
	{label : 'Noviembre' , value: 11},
	{label : 'Diciembre' , value: 12},
];

class BalanceGeneral extends React.Component{

	constructor(props){
		super(props)

		this.state = {
			contpaq : {
				balance_pasado:{ utilidad_perdida:0,
								utilidad_perdida_pasivos:0,}

			},
			 activeTab: '1',
			 buscar:0,
		}
		this.handleInputChange = this.handleInputChange.bind(this);
	    this.search = this.search.bind(this);
		this.guardar = this.guardar.bind(this);
		this.toggle_tab= this.toggle_tab.bind(this);
		this.handleSelectChange= this.handleSelectChange.bind(this);
		this.sumar = this.sumar.bind(this);
	}
	handleSelectChange(select, name) {

        
        const value = select === null ? null : select.value;
        this.setState({
           
             
                [name]: value,
                buscar:0,
        
        });
    }
	search(){
		let self = this;
		    api().get(`/buscar_balance_general/${this.state.mes}/${this.state.ano}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                
                     
                       
                       self.setState({
				        	contpaq : response.data,
				        	buscar:1,

				        });
                }

            });
	}
	toggle_tab(tab) {
        if (this.state.activeTab !== tab) {
          this.setState({
            activeTab: tab
          });
        }
      }

		formateo(value) {
			let etiqueta='$';

			var decimals =  2;
			var  separators =[',', ",", '.'];
			var number = (parseFloat(value) || 0).toFixed(decimals);
			if(number<0)
				etiqueta='$ -';

			if (number.length <= (4 + decimals))
			return etiqueta +number.replace('.', separators[separators.length - 1]);
			var parts = number.split(/[-.]/);
			value = parts[parts.length > 1 ? parts.length - 2 : 0];
			var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
			separators[separators.length - 1] + parts[parts.length - 1] : '');
			var start = value.length - 6;
			var idx = 0;
			while (start > -3) {
			result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
			+ separators[idx] + result;
			idx = (++idx) % 2;
			start -= 3;
			}
			return etiqueta + result;
		}


	guardar(){
   console.log('entro');
   let contpaq = this.state.contpaq;
   console.log('contpaq--->',contpaq);
   let self = this;
		if(contpaq.id==null){

			this.props.save(contpaq, (response) => {
				
							
					self.setState({contpaq : response});
					console.log('contpaq regresado--->',response);

					swal("Bien hecho!", "El reporte fue Registrado  con éxito!", "success");
				

			});

		}else{
			this.props.update(contpaq, (response) => {
				
							
					self.setState({contpaq : response});
					console.log('contpaq regresado--->',response);
					swal("Bien hecho!", "El reporte fue actualizado  con éxito!", "success");


			});

		}

	}
	 componentDidMount(){
	  let self = this;

	 	var fecha = new Date();
        var ano = fecha.getFullYear();
        let anos=[];

        for (var i = 5 ; i >= 0; i--) {
        	anos.unshift({label:(ano-i),value:(ano-i)});
        }



        this.setState({
        	mes : parseInt(fecha.getMonth())+1,
        	ano:ano,
        	anos:anos,
        });
       
        
        
    }


    quitar_comas(value){
    	let numero=''+value;
    	let output =numero.replace(',', '');
    	return output;

    }

	handleInputChange(event) {



		if(event === null) return;
        let{contpaq} = this.state;
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		let converted;
		converted = parseFloat( value,10);
		console.log('converted----->',converted)

		if(value== '' ||  isNaN(converted)){
			converted = '';
			console.log('vacio');
		}
		console.log('converted despues----->',converted)
		console.log('name-->',name);


		contpaq[name] = converted;
		// this.setState({contpaq: contpaq});
		 this.sumar(contpaq);


	}
	sumar(contpaq){
		contpaq.total_ingresos=parseFloat(contpaq.ventas,10)+ parseFloat(contpaq.remisiones,10)+ parseFloat(contpaq.final,10)-parseFloat(contpaq.inicial,10)-parseFloat(contpaq.equipos,10);
		contpaq.total_gastos=parseFloat(contpaq.administrativos,10)+parseFloat(contpaq.nomina,10)+parseFloat(contpaq.comisiones,10);
		contpaq.utilidad_perdida=parseFloat(contpaq.total_ingresos,10)- parseFloat(contpaq.total_gastos,10);

		contpaq.total_activos=parseFloat(contpaq.cuentas_cobrar,10)+ parseFloat(contpaq.bancos,10)+ parseFloat(contpaq.inventarios,10);
		contpaq.total_pasivos=parseFloat(contpaq.cuentas_pagar,10)+ parseFloat(contpaq.american_express,10);

		contpaq.utilidad_perdida_pasivos=parseFloat(contpaq.total_activos,10)- parseFloat(contpaq.total_pasivos,10);







        this.setState({contpaq: contpaq});


	}



	render(){

		let {contpaq,mes,ano} = this.state;
		console.log("state--->",this.state);

		let fecha_actual= new Date();

		let fecha_comprar= new Date(`${fecha_actual.getFullYear()}-${parseInt(fecha_actual.getMonth())+1}-01`);

		let fecha_reporte= new Date(`${ano}-${mes}-01`);

		let candado=true;
		if(fecha_comprar < fecha_reporte || (parseInt(fecha_comprar.getMonth())+1==mes&& fecha_comprar.getFullYear()==ano ) )
			candado=false;




		console.log('fecha_comprar---->',fecha_comprar);
		console.log('fecha_reporte---->',fecha_reporte);


		return(
		<Card className="px-3">
			<div className="mb-2"></div>
			<Nav tabs>
				<NavItem>
					<NavLink className={classnames({ active: this.state.activeTab === '1' })}	onClick={() => { this.toggle_tab('1'); }}	>
						Balance General
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent activeTab={this.state.activeTab}>
				<TabPane tabId="1">
				 <div className="row">
				 <div className="col-md-1"> 
                    <div className="form-group">
                    </div>
                 </div>
				<div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Mes:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="mes"
                            options={meses}
                            value={parseInt(this.state.mes) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'mes') } }
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-4"> 
                    <div className="form-group">
                        <label className>Año:</label>
                        <Select
                            placeholder=""
                            type="text"
                            name="ano"
                            options={this.state.anos}
                            value={parseInt(this.state.ano) || 1}
                           onChange={ (select) => { this.handleSelectChange(select, 'ano') } }
                            clearable={false}

                        />
                    </div>
                </div>
                <div className="col-md-3"> 
                    <div className="form-group">
                    					<label><br/></label><br/>
										<Button color='success' onClick={this.search}> <Fasearch/> </Button>
										{'  '}
										{contpaq.id!=null&&
											<Button color='primary' onClick={ (select) => { window.open(API_URL+"/pdf_balance_general/"+contpaq.id); } }> <FAprint/> </Button>

										}
										
                    </div>
                 </div>
                </div>

					<Row>
						<Col sm="12" >
							<div className="row mt-4">
								<div className="col-12 text-center">
									<h3 className="mt-4 ml-4">Ingresos</h3>
								</div>
							</div>
							<div className="row ">
								<div className="col-2">
									<div className="form-group">
										<label className>Ventas</label>
										<input 	type="text" className="form-control" name="ventas"	readOnly value={this.formateo(contpaq.ventas)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Remisiones</label>
										<input 	type="text" className="form-control" name="remisiones"	readOnly value={this.formateo(contpaq.remisiones)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>I. Final</label>
										<input 	type="text" className="form-control" name="final"	readOnly value={this.formateo(contpaq.final)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>I. Inicial</label>
										<input 	type="text" className="form-control" name="inicial"	readOnly value={this.formateo(contpaq.inicial)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Compras Equipo</label>
										<input 	type="text" className="form-control" name="equipos"	readOnly value={this.formateo(contpaq.equipos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Total Ingresos</label>
										<input 	type="text" className="form-control" name="total_ingresos"	readOnly value={this.formateo(contpaq.total_ingresos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-12 text-center">
									<h3 className="mt-4 ml-4">Egresos</h3>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-2">
									<div className="form-group">
										<label className>Gastos Administrativos</label>
										<input 	type="text" className="form-control" name="administrativos"	readOnly value={this.formateo(contpaq.administrativos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Nomina</label>
										<input 	type="number" step='0.01' className="form-control" name="nomina"	 value={contpaq.nomina} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Comisiones</label>
										<input 	type="number" step='0.01' className="form-control" name="comisiones"	 value={contpaq.comisiones} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Total Gastos</label>
										<input 	type="text" className="form-control" name="total_gastos"	readOnly value={this.formateo(contpaq.total_gastos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Utilidad/Perdida Pasada</label>
										<input 	type="text" className="form-control" name="utilidad_perdida"	readOnly value={this.formateo(contpaq.balance_pasado.utilidad_perdida)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Utilidad/Perdida</label>
										<input 	type="text" className="form-control" name="utilidad_perdida"	readOnly value={this.formateo(contpaq.utilidad_perdida)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-12 text-center">
									<h3 className="mt-4 ml-4">Activos</h3>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-2">
									<div className="form-group">
										<label className>Ctas. X Cobrar</label>
										<input 	type="text" className="form-control" name="cuentas_cobrar"	readOnly value={this.formateo(contpaq.cuentas_cobrar)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Bancos</label>
										<input 	type="text" className="form-control" name="bancos"	 value={contpaq.bancos} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Inventarios</label>
										<input 	type="text" className="form-control" name="inventarios"	readOnly value={this.formateo(contpaq.inventarios)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Total Activos</label>
										<input 	type="text" className="form-control" name="total_activos"	readOnly value={this.formateo(contpaq.total_activos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-12 text-center">
									<h3 className="mt-4 ml-4">Pasivos</h3>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-2">
									<div className="form-group">
										<label className>Ctas. X Pagar</label>
										<input 	type="text" className="form-control" name="cuentas_pagar"	readOnly value={this.formateo(contpaq.cuentas_pagar)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>American Express</label>
										<input 	type="text" className="form-control" name="american_express"	 value={contpaq.american_express} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">	
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Total Pasivos</label>
										<input 	type="text" className="form-control" name="total_pasivos"	readOnly value={this.formateo(contpaq.total_pasivos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<div className="row mt-4">
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Activos/Pasivos Pasada</label>
										<input 	type="text" className="form-control" name="utilidad_perdida_pasivos"	readOnly value={this.formateo(contpaq.balance_pasado.utilidad_perdida_pasivos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
								<div className="col-2">
									<div className="form-group">
										<label className>Activos/Pasivos</label>
										<input 	type="text" className="form-control" name="utilidad_perdida_pasivos"	readOnly value={this.formateo(contpaq.utilidad_perdida_pasivos)} onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
							<br/><br/>
							<div className="row">
								<div className="col-12 text-right">
								{(this.state.buscar==1)&&
									<Button color="success"  onClick={this.guardar} >
										&nbsp;Guardar
									</Button>
								}
								</div>
							</div>
							<br/><br/>
						</Col>
					</Row>
				</TabPane>
			</TabContent>
		</Card>
		)
	}

}

function mapStateToProps(state, ownProps) {
    return {
        balancegeneral : state.balancegeneral,
        auth:state.auth
    }
};

export default connect(mapStateToProps, actions)(BalanceGeneral)


// WEBPACK FOOTER //
// ./src/views/reportes/balance_general.js